import { useEffect } from 'react';

// Simple hook that monitors an error variable and call setError
// when its value change. Useful for components that can trigger an
// error message in its parent
const useError = (error, setError) => {
  useEffect(() => {
    setError(error);
  }, [error, setError])
}

export default useError;
